import { render } from "./ModalGallery.vue?vue&type=template&id=d9a533b4&scoped=true"
import script from "./ModalGallery.vue?vue&type=script&lang=js"
export * from "./ModalGallery.vue?vue&type=script&lang=js"

import "./ModalGallery.vue?vue&type=style&index=0&id=d9a533b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a533b4"]])

export default __exports__